let backendHost;

const hostname = window && window.location && window.location.hostname;
if (hostname === 'tcrmembershipportalclient.azurewebsites.net' || hostname === 'membership.tscra.org') {
    backendHost = 'https://tcrmembershipportalapi.azurewebsites.net';
} else if (hostname === 'tcrmembershipportalclient-staging.azurewebsites.net') {
    backendHost = 'https://tcrmembershipportalapi-staging.azurewebsites.net';
} else if (hostname === 'tcrmembershipportalclient-preprod.azurewebsites.net') {
    backendHost = 'https://tcrmembershipportalapi-preprod.azurewebsites.net';
} else if (hostname === 'tscramembershipportal-qa.azurewebsites.net') {
    backendHost = `https://tscramembershipportalapi-qa.azurewebsites.net`;
} else if (hostname === 'tcrmembershipportalclient-staging.tscra.org') {
    backendHost = `https://tcrmembershipportalapi-staging.tscra.org`;
} else if (hostname === 'tscramembershipportal.azurewebsites.net') {
    backendHost = `https://tscramembershipportalapi.azurewebsites.net`;
} else if (hostname === 'tscramembershipcenter-dev-webclient.azurewebsites.net') {
    backendHost = `https://tscramembershipcenter-dev-api.azurewebsites.net`;
} else {
    backendHost = process.env.REACT_APP_BACKEND_HOST || `https://localhost:3001`;
}

export const ROOT_API_URL = `${backendHost}/api`;
export const ODATA_API_URL = `${backendHost}/odata`;